import React, { useEffect } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { ContactType, EntityType } from "../model";
import { actions } from "../store";
import { selectMyRegionId, selectMyself, selectRegions, selectFavExtensionFolderId, selectFavContactFolderId, selectMyAccess } from "../store/reducers/config";
import { DirectoryView, selectDirectoryView } from "../store/reducers/localSettings";
import ContactsPage from "./ContactsPage";
import ExtesnionsPage from "./ExtensionsPage";
import { TabButton, TabsHeader } from './Tabs';

export default function DirectoryPage() {
  console.log('Render DirectoryPage')

  const dispatch = useDispatch()
  const view = useSelector(selectDirectoryView)
  const mySelf = useSelector(selectMyself)
  const myRegionId = useSelector(selectMyRegionId)
  const regions = useSelector(selectRegions)
  const eFolderId = useSelector(selectFavExtensionFolderId)
  const cFolderId = useSelector(selectFavContactFolderId)
  const access = useSelector(selectMyAccess)

  //resets unknown default value to users only region
  useEffect((() => {
    if (!myRegionId) return
    if (view.regionId === 'personal' && view.entityType === EntityType.Extension && view.contactType === undefined) {
      dispatch(actions.setDirectoryView({ regionId: myRegionId, entityType: EntityType.Extension }))
    } else if (view.regionId === 'favourite') {
      if (view.entityType === EntityType.Extension) {
        dispatch(actions.setDirectoryView({ regionId: eFolderId, entityType: EntityType.Extension } as DirectoryView))
      } else {
        dispatch(actions.setDirectoryView({ regionId: cFolderId, entityType: EntityType.Contact, contactType: ContactType.Personal } as DirectoryView))
      }
    } else if (view.regionId === cFolderId && view.entityType === EntityType.Contact && view.contactType !== ContactType.Personal) {
      dispatch(actions.setDirectoryView({ regionId: view.regionId, entityType: EntityType.Contact, contactType: ContactType.Personal } as DirectoryView))
    } else if(view.regionId !== cFolderId && view.regionId !== myRegionId && view.entityType === EntityType.Contact && view.contactType === ContactType.Personal){
      dispatch(actions.setDirectoryView({ regionId: view.regionId, entityType: EntityType.Contact, contactType: ContactType.Company } as DirectoryView))
    }

  }), [dispatch, regions, view.regionId, view.entityType, view.contactType, eFolderId, cFolderId, myRegionId])

  if (!mySelf || !myRegionId || !regions || !access) return null

  const table = (view.entityType === EntityType.Extension) ? <ExtesnionsPage /> : <ContactsPage />
  const fav = (eFolderId === view.regionId || cFolderId === view.regionId)

  function extensions() {
    dispatch(actions.setDirectoryView({ regionId: view.regionId, entityType: EntityType.Extension, contactType: view.contactType }))
  }

  function favExtensions() {
    if (!eFolderId) return

    dispatch(actions.setDirectoryView({ regionId: eFolderId, entityType: EntityType.Extension, contactType: ContactType.Personal }))
  }

  function favContacts() {
    if (!cFolderId) return

    dispatch(actions.setDirectoryView({ regionId: cFolderId, entityType: EntityType.Contact, contactType: ContactType.Personal }))
  }

  function myContacts() {
    if (!myRegionId) return

    dispatch(actions.setDirectoryView({ regionId: myRegionId, entityType: EntityType.Contact, contactType: ContactType.Personal }))
  }

  function contacts(type: ContactType) {
    dispatch(actions.setDirectoryView({ regionId: view.regionId, entityType: EntityType.Contact, contactType: type }))
  }

  return <><TabsHeader className='tab-buttons'>
    {fav && access.features.toolbarDirectory && <TabButton active={eFolderId === view.regionId} onClick={favExtensions}>Extensions</TabButton>}
    {fav && (access.features.companyContactsAccess || access.features.directoryCompanyContactAdd || access.features.directoryPersonalContactAdd) && <TabButton active={cFolderId === view.regionId} onClick={favContacts}>Contacts</TabButton>}

    {!fav && access.features.toolbarDirectory && <TabButton active={view.entityType === EntityType.Extension} onClick={extensions}>Extensions</TabButton>}
    {!fav && access.features.directoryPersonalContactAdd && view.regionId === myRegionId && <TabButton active={view.regionId === myRegionId && view.entityType === EntityType.Contact && view.contactType === ContactType.Personal} onClick={myContacts}>My Contacts</TabButton>}
    {!fav && (access.features.companyContactsAccess || access.features.directoryCompanyContactAdd) && <TabButton active={view.entityType === EntityType.Contact && view.contactType === ContactType.Company} onClick={() => contacts(ContactType.Company)}>Company</TabButton>}
    {!fav && (access.features.companyContactsAccess || access.features.directoryCompanyContactAdd) && <TabButton active={view.entityType === EntityType.Contact && view.contactType === ContactType.Customer} onClick={() => contacts(ContactType.Customer)}>Customers</TabButton>}
  </TabsHeader> {table}</>
}
